import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "context";
import AuthService from "services/auth-service";
// import DashboardIntroStep from "./steps/DashboardIntroStep"; // Now imported in Dashboard/index.js

function TutorialManager() {
    const { isAuthenticated } = useContext(AuthContext);
    const [currentStep, setCurrentStep] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!isAuthenticated) return;

        const fetchTutorialStatus = async () => {
            try {
                const resp = await AuthService.getProfile();
                const userData = resp.data.attributes;
                setCurrentUser(userData);

                const completedSteps = userData.completed_tutorials || [];

                // Global Tutorial Checks (if any remain)
                // Currently, 'connect_own_profile', 'dashboard_intro', and 'platform_scout_intro' 
                // are handled locally in their respective components/pages.

            } catch (error) {
                console.error("Failed to fetch user profile for tutorial:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTutorialStatus();
    }, [isAuthenticated]);

    const handleCompleteTutorial = async (stepId) => {
        try {
            // Update Backend
            const currentCompleted = currentUser?.completed_tutorials || [];
            if (currentCompleted.includes(stepId)) {
                setCurrentStep(null);
                return;
            }

            const updatedTutorials = [...currentCompleted, stepId];

            await AuthService.updateProfile({
                data: {
                    attributes: {
                        completed_tutorials: updatedTutorials
                    }
                }
            });

            // Close Modal
            setCurrentStep(null);
        } catch (error) {
            console.error("Failed to mark tutorial as complete:", error);
            setCurrentStep(null);
        }
    };

    const handleSkip = () => {
        setCurrentStep(null);
    };

    if (!isAuthenticated || loading || !currentStep) return null;

    return (
        <>
            {/* Global steps can be rendered here */}
        </>
    );
}

export default TutorialManager;
